import { render, staticRenderFns } from "./AdditionalOptionsGroup.vue?vue&type=template&id=70e707ca&scoped=true&"
import script from "./AdditionalOptionsGroup.vue?vue&type=script&lang=ts&"
export * from "./AdditionalOptionsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalOptionsGroup.vue?vue&type=style&index=0&id=70e707ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e707ca",
  null
  
)

export default component.exports